import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "navbar" };
const _hoisted_2 = { class: "navbar__inner" };
const _hoisted_3 = { class: "navbar__links" };
const _hoisted_4 = { class: "navbar__portfolio-menu" };
const _hoisted_5 = {
    ref: "langRoot",
    class: "navbar__lang"
};
const _hoisted_6 = ["aria-expanded"];
const _hoisted_7 = {
    class: "navbar__lang-menu",
    role: "listbox"
};
const _hoisted_8 = ["aria-selected", "onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
                to: _ctx.localizedTo('home'),
                class: "navbar__brand"
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('nav.brand')), 1)
                ]),
                _: 1
            }, 8, ["to"]),
            _createElementVNode("ul", _hoisted_3, [
                _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                        to: { ..._ctx.localizedTo('home'), hash: '#services' },
                        class: "navbar__link"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('nav.services')), 1)
                        ]),
                        _: 1
                    }, 8, ["to"])
                ]),
                _createElementVNode("li", {
                    ref: "portfolioRoot",
                    class: "navbar__portfolio",
                    onMouseenter: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.openPortfolio && _ctx.openPortfolio(...args))),
                    onMouseleave: _cache[3] || (_cache[3] =
                        //@ts-ignore
                        (...args) => (_ctx.closePortfolio && _ctx.closePortfolio(...args)))
                }, [
                    _createVNode(_component_router_link, {
                        to: _ctx.localizedTo('portfolio'),
                        class: "navbar__link",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.portfolioOpen = false))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('nav.portfolio')), 1)
                        ]),
                        _: 1
                    }, 8, ["to"]),
                    _withDirectives(_createElementVNode("ul", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portfolioOptions, (opt) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: opt.value
                            }, [
                                _createVNode(_component_router_link, {
                                    to: _ctx.localizedTo('portfolio-category', { category: opt.value }),
                                    class: "navbar__portfolio-option",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.portfolioOpen = false))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(opt.label), 1)
                                    ]),
                                    _: 2
                                }, 1032, ["to"])
                            ]));
                        }), 128))
                    ], 512), [
                        [_vShow, _ctx.portfolioOpen]
                    ])
                ], 544)
            ]),
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                    type: "button",
                    class: "navbar__lang-toggle",
                    "aria-expanded": _ctx.langOpen,
                    "aria-haspopup": "listbox",
                    onClick: _cache[4] || (_cache[4] =
                        //@ts-ignore
                        (...args) => (_ctx.toggleLang && _ctx.toggleLang(...args)))
                }, [
                    _createTextVNode(_toDisplayString(_ctx.locale.toUpperCase()) + " ", 1),
                    (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass(["navbar__lang-caret", { 'navbar__lang-caret--open': _ctx.langOpen }]),
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "1.6",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "aria-hidden": "true"
                    }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                        ]))], 2))
                ], 8, _hoisted_6),
                _withDirectives(_createElementVNode("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langOptions, (opt) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: opt.code
                        }, [
                            _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["navbar__lang-option", { 'navbar__lang-option--active': _ctx.locale === opt.code }]),
                                role: "option",
                                "aria-selected": _ctx.locale === opt.code,
                                onClick: ($event) => (_ctx.pickLang(opt.code))
                            }, _toDisplayString(opt.label), 11, _hoisted_8)
                        ]));
                    }), 128))
                ], 512), [
                    [_vShow, _ctx.langOpen]
                ])
            ], 512)
        ])
    ]));
}
